howspace.userlist = (() => {
    'use strict';

    const initUserListModal = (modal) => {
        modal.find('#userlist-name-input').on('input', function (e) {
            if (real.trim(modal.find('#userlist-name-input').val()) === '') {
                modal.find('.modal-footer .save-btn').prop('disabled', true);
            } else {
                modal.find('.modal-footer .save-btn').prop('disabled', false);
            }
        });
    };

    const getUserlistModalPayload = (modal) => {
        const dataPayload = real.form.getDataPayload(modal);

        if (dataPayload.filter) {
            dataPayload.user_profile_field = dataPayload.filter.limit_results_to_user_profile_field;
            delete dataPayload.filter;
        }

        return dataPayload;
    };

    const initCreateModal = (modal) => {
        modal = $(modal);

        initUserListModal(modal);

        modal.on('click', '.user-profile-field-child-btn', function () {
            const btn = $(this);
            const profileField = btn.closest('.user-profile-field');
            const profileFieldName = profileField.data('name');
            const profileFieldId = profileField.data('user-profile-field-id');
            const value = btn.data('value');

            setTimeout(function () {
                modal.find('.user-profile-field-input').val(profileFieldId + ':' + value);
                modal.find('.selected-user-profile-field .user-profile-field-name').text(profileFieldName);
                modal.find('.selected-user-profile-field .user-profile-field-value').text(btn.text());
                modal.find('.selected-user-profile-field-wrapper').removeClass('d-none');

                modal.find('.profile-field-card').addClass('d-none');
            }, 100);
        });

        const removeUserProfileField = function () {
            modal.find('.user-profile-field-input').val('');
            modal.find('.selected-user-profile-field-wrapper').addClass('d-none');
            modal.find('.profile-field-card').removeClass('d-none');
            modal.find('.selected-user-profile-field .user-profile-field-name').html('');
            modal.find('.selected-user-profile-field .user-profile-field-value').html('');
        }

        modal.find('.members-type-radio').on('change', function (e) {
            removeUserProfileField();
        });

        modal.on('click', '.remove-user-profile-field-btn', removeUserProfileField);

        modal.find('.modal-footer #create-userlist-btn').on('click', function (e) {
            const btn = $(this);
            real.button.loading(btn, modal);

            const dataPayload = getUserlistModalPayload(modal);

            real.ajax.json(real.baseUri + '/api/userlists', {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: function (response) {
                    real.button.reset(btn, modal);
                    howspace.components.lister.reload($('#userlists-active-lister'));
                    howspace.components.modal.close(modal[0]);
                },
                error: function (response) {
                    real.button.reset(btn, modal);
                }
            });
        });
    };

    const initProfileModal = modal => {
        modal = $(modal);

        initUserListModal(modal);

        modal.find('.modal-footer .save-btn').on('click', function (e) {
            const btn = $(this);
            real.button.loading(btn, modal);

            const dataPayload = getUserlistModalPayload(modal);

            real.ajax.json(real.baseUri + '/api/userlist/' + modal.data('userlist-id'), {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: () => {
                    howspace.components.modal.close(modal);
                },
                error: () => {
                    real.button.reset(btn, modal);
                }
            });
        });
    };

    return {
        initCreateModal: initCreateModal,
        initProfileModal: initProfileModal
    };
})();
